/* ==========================================================================
   AeroFlex — JS propio. Vanilla, sin librerias externas.
   Una funcion init por componente; cada una sale si su elemento no existe.
   ========================================================================== */
(function () {
  'use strict';

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada -------------------------------------------- */
  function initReveal() {
    var elementos = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!elementos.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) {
        el.classList.add('mt-visible');
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('mt-visible');
          obs.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    elementos.forEach(function (el) {
      obs.observe(el);
    });

    // Red de seguridad: lo que ya esta a la vista se muestra si o si.
    function revelarLoVisible() {
      document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
        var caja = el.getBoundingClientRect();
        if (caja.top < window.innerHeight && caja.bottom > 0) {
          el.classList.add('mt-visible');
          obs.unobserve(el);
        }
      });
    }
    revelarLoVisible();
    window.addEventListener('load', function () {
      setTimeout(revelarLoVisible, 300);
    });
  }

  /* --- Cifras animadas ---------------------------------------------------- */
  function initCifras() {
    var cifras = document.querySelectorAll('.mt-cifra__num[data-mt-hasta]');
    if (!cifras.length) return;

    function pintar(el, valor) {
      el.textContent =
        (el.getAttribute('data-mt-antes') || '') +
        valor.toLocaleString('es-CO') +
        (el.getAttribute('data-mt-despues') || '');
    }

    function contar(el) {
      var hasta = parseFloat(el.getAttribute('data-mt-hasta')) || 0;
      if (reduce) {
        pintar(el, hasta);
        return;
      }
      var inicio = null;
      var dur = 1400;
      function paso(t) {
        if (inicio === null) inicio = t;
        var p = Math.min((t - inicio) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        pintar(el, Math.round(hasta * eased));
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      cifras.forEach(contar);
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          contar(e.target);
          obs.unobserve(e.target);
        });
      },
      { threshold: 0.4 }
    );

    cifras.forEach(function (el) {
      obs.observe(el);
    });
  }

  /* --- Escena de pasos (visual sticky que cambia) ------------------------- */
  function initPasos() {
    var escenas = document.querySelectorAll('[data-mt-pasos]');
    if (!escenas.length) return;

    escenas.forEach(function (escena) {
      var pasos = escena.querySelectorAll('.mt-paso');
      var imagenes = escena.querySelectorAll('.mt-pasos__visual img');
      if (!pasos.length || !imagenes.length) return;

      function activar(indice) {
        pasos.forEach(function (p, i) {
          p.classList.toggle('mt-activo', i === indice);
        });
        imagenes.forEach(function (img, i) {
          img.classList.toggle('mt-activa', i === indice);
        });
      }

      activar(0);

      if (!('IntersectionObserver' in window)) return;

      var obs = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (e) {
            if (!e.isIntersecting) return;
            var i = parseInt(e.target.getAttribute('data-mt-indice'), 10);
            if (!isNaN(i)) activar(i);
          });
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );

      pasos.forEach(function (p) {
        obs.observe(p);
      });
    });
  }

  /* --- Carrusel de resenas ------------------------------------------------ */
  function initCarrusel() {
    var wraps = document.querySelectorAll('[data-mt-carrusel]');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      var pista = wrap.querySelector('.mt-carrusel');
      var anterior = wrap.querySelector('[data-mt-anterior]');
      var siguiente = wrap.querySelector('[data-mt-siguiente]');
      if (!pista || wrap.dataset.mtListo) return;
      wrap.dataset.mtListo = '1';

      function salto() {
        var primera = pista.querySelector('.mt-resena');
        return primera ? primera.getBoundingClientRect().width + 22 : 340;
      }

      if (siguiente) {
        siguiente.addEventListener('click', function () {
          pista.scrollBy({ left: salto(), behavior: reduce ? 'auto' : 'smooth' });
        });
      }
      if (anterior) {
        anterior.addEventListener('click', function () {
          pista.scrollBy({ left: -salto(), behavior: reduce ? 'auto' : 'smooth' });
        });
      }
    });
  }

  /* --- FAQ desplegable ---------------------------------------------------- */
  function initFaq() {
    var botones = document.querySelectorAll('.mt-faq__btn');
    if (!botones.length) return;

    botones.forEach(function (btn) {
      if (btn.dataset.mtListo) return;
      btn.dataset.mtListo = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq__item');
        if (!item) return;
        var abierto = item.classList.contains('mt-abierto');
        item.classList.toggle('mt-abierto', !abierto);
        btn.setAttribute('aria-expanded', String(!abierto));
      });
    });
  }

  /* --- Galeria de la pagina de producto ----------------------------------- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-principal]');
      var minis = galeria.querySelectorAll('[data-mt-mini]');
      if (!principal || !minis.length) return;

      if (galeria.dataset.mtListo) return;
      galeria.dataset.mtListo = '1';

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-mt-src');
          if (src) principal.setAttribute('src', src);
          minis.forEach(function (m) {
            m.classList.remove('mt-activa');
          });
          mini.classList.add('mt-activa');
        });
      });
    });
  }

  /* --- Selector de variantes ---------------------------------------------- */
  function initVariantes() {
    var bloques = document.querySelectorAll('[data-mt-variantes]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var datos = bloque.querySelector('[data-mt-variantes-json]');
      if (!datos) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(variantes) || !variantes.length) return;
      if (bloque.dataset.mtListo) return;
      bloque.dataset.mtListo = '1';

      var inputId = bloque.querySelector('[data-mt-variante-id]');
      var precio = bloque.querySelector('[data-mt-precio]');
      var precioAntes = bloque.querySelector('[data-mt-precio-antes]');
      var boton = bloque.querySelector('[data-mt-anadir]');
      var aviso = bloque.querySelector('[data-mt-agotado]');
      var grupos = bloque.querySelectorAll('[data-mt-opcion]');
      var moneda = bloque.getAttribute('data-mt-moneda') || '';
      var textoAgotado = bloque.getAttribute('data-mt-texto-agotado') || 'Agotado';
      var textoAnadir = boton ? boton.getAttribute('data-mt-texto') || boton.textContent : '';

      function formatear(centavos) {
        var valor = (centavos || 0) / 100;
        try {
          return valor.toLocaleString('es-CO', {
            style: 'currency',
            currency: moneda || 'COP',
            minimumFractionDigits: valor % 1 === 0 ? 0 : 2,
          });
        } catch (e) {
          return valor.toLocaleString('es-CO');
        }
      }

      function seleccionadas() {
        var out = [];
        grupos.forEach(function (grupo) {
          var activa = grupo.querySelector('.mt-prod__pastilla.mt-activa');
          out.push(activa ? activa.getAttribute('data-mt-valor') : null);
        });
        return out;
      }

      function actualizar() {
        var sel = seleccionadas();
        var v = variantes.find(function (variante) {
          return sel.every(function (valor, i) {
            return valor === null || variante.options[i] === valor;
          });
        });

        if (!v) return;

        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = formatear(v.price);
        if (precioAntes) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            precioAntes.textContent = formatear(v.compare_at_price);
            precioAntes.hidden = false;
          } else {
            precioAntes.hidden = true;
          }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.textContent = v.available ? textoAnadir : textoAgotado;
        }
        if (aviso) aviso.hidden = v.available;
      }

      grupos.forEach(function (grupo) {
        grupo.querySelectorAll('.mt-prod__pastilla').forEach(function (pastilla) {
          pastilla.addEventListener('click', function () {
            grupo.querySelectorAll('.mt-prod__pastilla').forEach(function (p) {
              p.classList.remove('mt-activa');
            });
            pastilla.classList.add('mt-activa');
            actualizar();
          });
        });
      });
    });
  }

  function arrancar() {
    window.__mtListo = true;
    initReveal();
    initCifras();
    initPasos();
    initCarrusel();
    initFaq();
    initGaleria();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de Shopify recarga secciones sueltas: volvemos a inicializar.
  document.addEventListener('shopify:section:load', arrancar);
})();
